import {Extension, Plugin, Node} from 'tiptap'; // eslint-disable-line
import {chainCommands, exitCode} from 'tiptap-commands';
// export default class EnterHandler extends Extension {
//
//     get name() {
//         return 'enter_handler'
//     }
//
//     get plugins() {
//         return [
//             new Plugin({
//                 props: {
//                     handleKeyDown: (view, event) => {
//
//                         if (event.key === 'Enter' && !event.shiftKey) {
//                             // do something
//                             window.console.log(view);
//                             return true
//                         }
//
//                         return false
//                     },
//                 },
//             }),
//         ]
//     }
//
// }
export default class EnterHandler extends Node {

    get name () {
        return 'enter_handler';
    }
    get defaultOptions() {
        return {
            onEnter: (view, event) => {
                if (event.key === 'Enter' && !event.shiftKey) {
                    // do something
                    return  true
                }

                return false
            }
        }
    }
    get schema () {
        return {
            inline: true,
            group: 'inline',
            selectable: false,
            parseDOM: [
                {tag: 'br'}
            ],
            toDOM: () => ['br']
        };
    }
    get plugins() {
        return [
            new Plugin({
                props: {
                    handleKeyDown: (view, event) => {
                        return this.options.onEnter(view, event)
                    },
                },
            }),
        ]
    }
    keys ({type}) {
        const command = chainCommands(exitCode, (state, dispatch) => {
            dispatch(state.tr.replaceSelectionWith(type.create()).scrollIntoView());
            return true;
        });
        return {
            'Mod-Enter': command,
            'Shift-Enter': command
        };
    }

}
